module.exports = __webpack_public_path__ + "static/media/Batrider.c68f97e0.png";